import FormItem from "@components/formItem";
import { StakeFieldWrapper } from "@pages/profile-v2/pages/deposit/baseItems";
import { BoxWrapper } from "@pages/profile/withdraw/baseItems";
import { getUser } from "@utils";
import React, { Fragment } from "react";
import MaskInput from "react-maskinput";
import { Box, Content, ContentTitle, MaskedInput, MaskedInputLabel } from "../baseItems";
import Base from "./base";

export default class AnindaMFT extends Base {
	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			showAccountMask: false,
			accountNumber: "",
			accountNumberValue: "",
			canForward: false,
		};
		this.accountInputRef = React.createRef();
	}

	componentDidMount() {
		this.checkRequiredFields();
		super.componentDidMount();
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			prevState.accountNumber !== this.state.accountNumber ||
			prevState.accountNumberValue !== this.state.accountNumberValue ||
			prevState.stake !== this.state.stake ||
			prevState.selectedCurrency !== this.state.selectedCurrency
		) {
			this.checkRequiredFields();
		}
	}

	handleFocus = (field) => {
		this.setState({ [field]: true });
		const inputRef = this.accountInputRef;
		if (inputRef.current) {
			const value = inputRef.current.input.value;
			const position = value.indexOf("_") !== -1 ? value.indexOf("_") : value.length;
			inputRef.current.input.setSelectionRange(position, position);
		}
	};

	handleBlur = (field, value) => {
		const cleanedValue = value.replace(/_/g, "").trim();
		const isEmptyOrMasked = cleanedValue === "";
		this.setState(
			{
				[field]: false,
				[`${field.replace("show", "").toLowerCase()}Value`]: isEmptyOrMasked
					? ""
					: cleanedValue,
			},
			this.checkRequiredFields
		);
	};

	onEnterValue = (field, e) => {
		const value = e.target.value.replace(/_/g, "").trim();
		this.setState({ [field]: value, [`${field}Value`]: value }, this.checkRequiredFields);
	};

	checkRequiredFields = () => {
		const { accountNumberValue, stake, selectedCurrency } = this.state;
		if (accountNumberValue && stake && selectedCurrency) {
			this.setState({ canForward: true });
		} else {
			this.setState({ canForward: false });
		}
	};

	getStep1(translate) {
		const { stake, selectedCurrency, showAccountMask, accountNumber, accountNumberValue } =
			this.state;
		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<BoxWrapper>
					{this.getCurrencyField(translate)}
					<StakeFieldWrapper>
						<div className="stake-field">{this.getStakeField()}</div>
						<div className="min-max-field">{this.renderMinMax()}</div>
					</StakeFieldWrapper>
				</BoxWrapper>
				<BoxWrapper>
					<Fragment>
						<FormItem onRegister={() => this.registerField({ name: "account" })}>
							<Box>
								<MaskedInput>
									<MaskInput
										ref={this.accountInputRef}
										alwaysShowMask={window.IS_MARS ? true : false}
										onFocus={() => this.handleFocus("showAccountMask")}
										onBlur={(e) =>
											this.handleBlur("showAccountMask", e.target.value)
										}
										maskChar={showAccountMask ? "_" : ""}
										mask="00000000000000000000"
										size={26}
										onChange={(e) => this.onEnterValue("accountNumber", e)}
										value={showAccountMask ? accountNumber : accountNumberValue}
									/>
									<MaskedInputLabel
										isFocused={showAccountMask}
										hasValue={accountNumberValue}>
										{translate("ACCOUNT_NUMBER")}
									</MaskedInputLabel>
								</MaskedInput>
							</Box>
						</FormItem>
					</Fragment>
				</BoxWrapper>
			</Content>
		);
	}

	goForward(step) {
		const { stake, selectedCurrency } = this.state;
		const { selectedWithdraw } = this.props;

		if (!this.state.canForward) return;

		const currency = selectedWithdraw.currencies.find(
			(item) => item.currency === selectedCurrency
		);

		if (currency && stake < currency.withdraw.min) {
			this.props.showAlert({
				type: "error",
				msg: "STAKE_RANGE_WARNING_MIN",
				title: "ERROR",
			});
			return;
		}

		if (currency && stake > currency.withdraw.max) {
			this.props.showAlert({
				type: "error",
				msg: "STAKE_RANGE_WARNING_MAX",
				title: "ERROR",
			});
			return;
		}

		const newStep = step + 1;
		this.setState({ currentStep: newStep });
	}

	makeExternalPayment() {
		const { stake, accountNumberValue, selectedCurrency } = this.state;
		let withdrawData = {
			type: "AnindaMFT",
			username: getUser().username,
			sessionId: getUser().sessionId,
			amount: {
				value: Number(stake),
				currency: selectedCurrency,
			},
			account_number: accountNumberValue,
			language: this.getActiveLanguageCode(),
			note: new Date(),
		};
		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}

	render() {
		const { canForward } = this.state;
		return super.render();
	}
}
